module.exports = __webpack_public_path__ + "img/a.21e27539.jpg";